(function() {
  function nudge() {
    // レイアウト再計測を促す
    window.dispatchEvent(new Event('resize'));

    // Dawnのbanner/slideshowの高さを手当（必要ならクラス名を追加）
    document.querySelectorAll('.banner__media, .slideshow__media').forEach(function(el) {
      el.style.height = 'auto';
      el.style.maxHeight = '80vh';
      const img = el.querySelector('img');
      if (img) {
        img.style.transform = 'none';
        img.style.height = 'auto';
        img.style.width  = '100%';
        img.style.objectFit = 'cover';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', nudge);
  document.addEventListener('shopify:section:load', nudge);
  document.addEventListener('shopify:section:select', nudge);
  document.addEventListener('shopify:block:select', nudge);
  document.addEventListener('shopify:block:deselect', nudge);
  document.addEventListener('shopify:inspector:change', nudge);
})();
